import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import { EventBusService } from "../../core/services/event-bus.service";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { TimesheetService } from "../../shared/services/timesheet.service";
import { SharedDataService } from "../../shared/sharedData.service";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcModalConfirmation } from "../../shared/component/confirmation/nbc-modal-confirmation.component";
import { forkJoin, Observable } from "rxjs";
import { AuthorizationService } from "../../shared/services/authorization.service";

@Component({
    selector: "ops-tal-dept",
    templateUrl: "./ops-tal-dept.component.html",
    standalone: false
})
export class OpsTalentDeptComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBus: EventBusService,
        private timesheetService: TimesheetService,
        private _sharedDataService: SharedDataService,
        public _modalService: BsModalService,
        private authorizationService: AuthorizationService,
        private log: NbcLoggerService
    ) {}
    buAccess: any;

    private subs = new SubSink();
    modalConfirmationRef?: BsModalRef;
    selectedBusinessUnit: any;
    dashboardListItems: any[] = [];
    dashboardData: any = this.getDashboardObj();
    pagination_display: any = true;
    result: any = true;
    queryContainer: any;
    operationTalentDept: any = null;
    departmentsWithTimesheets = ["SUBMITTER"];
    DepartmentsWithTimesheets = ["SUBMITTER", "APPROVER"];
    DepartmentsWithTimecards = ["FINANCE", "PAYROLL"];

    getDashboardObj() {
        return {
            items: null,
            buAccess: null,
        };
    }

    getQueryContainer() {
        const query = this.timesheetService.getTimesheetSummaryQuery();
        return {
            query: query,
        };
    }

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data;
        this.onActiveTimesheets();
    }

    onActiveTimesheets() {
        this.pagination_display = true;
        this.result = true;
        this.queryContainer.query.currentPage = 1;
        this.timesheetSummary(false);
    }

    onCompltedTimesheets() {
        this.pagination_display = true;
        this.result = true;
        this.timesheetSummary(true);
    }

    onReportTab() {
        this.result = false;
        this.pagination_display = false;
    }

    onTimecardTab() {
        this.pagination_display = false;
    }

    timesheetSummary(isCompleted) {
        this.queryContainer.query.isCompleted = isCompleted;
        this.getTimesheetSummary(this.selectedBusinessUnit.id);
    }

    eventSearch(event) {
        this.queryContainer.query.currentPage = event.page;
        this.getTimesheetSummary(this.selectedBusinessUnit.id);
    }

    // Search Contact
    contactSearch(data: any) {
        this.queryContainer.query.businessUnitId = data.selectedBusinessUnitId;
        this.queryContainer.query.departmentId = data.departmentId;
        this.queryContainer.query.searchTerm.description = data.description;
        this.queryContainer.query.currentPage = 1;

        this.getTimesheetSummary(data.selectedBusinessUnitId);
    }

    getTimesheetSummary(buId) {
        this.queryContainer.query.businessUnitId = buId;
        this.dashboardData = null;

        this.timesheetService
            .getTimesheetSummary(this.queryContainer.query)
            .subscribe({
                next: (result: any) => {
                    this.dashboardListItems = result.items;
                    this.queryContainer.query.pageSize = result.pageSize;
                    this.queryContainer.query.currentPage = result.currentPage;
                    this.queryContainer.query.totalRecords =
                        result.totalRecords;
                    this.queryContainer.query.selectedTab = result.selectedTab;
                    this.dashboardData = this.getDashboardObj();
                    this.dashboardData.items = this.dashboardListItems;
                    this.dashboardData.buAccess = this.buAccess;
                    this._sharedDataService.setBuAccess(this.buAccess);
                },
                error: (err) => {
                    this.log.showError(
                        "Unable to load the timesheet Summary at this time. Please try again later."
                    );
                },
            });
    }

    deleteTimesheet(listItemId) {
        this.log.trace("Delete Timesheet");
        this.showTalentPayrollMessage(
            "scorePay",
            "Are you sure you want to delete the Timesheet?",
            true,
            this.deleteSelectedTimesheet,
            [listItemId],
            "OK",
            "Cancel",
            null,
            null
        );
    }

    deleteSelectedTimesheet(listItemId) {
        this.log.trace("Delete Timesheet:" + listItemId);
        this.queryContainer.query.batchid = listItemId;
        this.queryContainer.query.departmentId = this.buAccess.departmentId;
        this.queryContainer.query.businessUnitId = this.buAccess.businessUnitId;

        this.timesheetService.delete(this.queryContainer.query).subscribe({
            next: (result) => {
                this.queryContainer.query.pageSize = result.pageSize;
                this.queryContainer.query.currentPage = result.currentPage;
                this.queryContainer.query.totalRecords = result.totalRecords;
                this.queryContainer.query.selectedTab = result.selectedTab;
                this.dashboardData.items = result.items;
                this.dashboardData.buAccess = this.buAccess;
            },
            error: (err) => {
                this.log.error("got an error: " + JSON.stringify(err));
                this.log.showError(
                    "Unable to delete the Timesheet at this time. Please try again later."
                );
            },
        });
    }

    showTalentPayrollMessage(
        title,
        message,
        canUpdate,
        callback,
        args,
        confirmText,
        cancelText,
        cancelCallback,
        cancelargs
    ) {
        //let modalConfirmationRef: BsModalRef;

        const initialState: any = {
            self: this,
            modalTitle: title,
            modalMessage: message,
            confirmText: confirmText || "Continue",
            cancelText: !canUpdate ? "Close" : cancelText || undefined,
            hideConfirm: !canUpdate,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        this.modalConfirmationRef = this._modalService.show(
            NbcModalConfirmation,
            modalOptions
        );
        this.modalConfirmationRef.content.onAffirmation.subscribe((result) => {
            callback.apply(this, args);
        });
        this.modalConfirmationRef.content.onRejection.subscribe((result) => {
            cancelCallback.apply(this, cancelargs);
        });
    }

    getData = () => {
        const buAccess$ = this.authorizationService.getBUAccess(
            this.selectedBusinessUnit.id
        );
        this.subs.sink = forkJoin(buAccess$).subscribe(([access]) => {
            this.configureBusinessUnitAccess(access.reference);
        });
    };

    configureBusinessUnitAccess(access: any) {
        this.buAccess = access;
        this.operationTalentDept = _.includes(
            this.departmentsWithTimesheets,
            this.buAccess.department
        );
    }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((access) => (this.buAccess = access));

        this.subs.sink = this._eventBus.on("contactSearch", (listItem) => {
            this.contactSearch(listItem);
        });

        this.subs.sink = this._eventBus.on("onDeleteTimesheet", (listItem) => {
            this.deleteTimesheet(listItem);
        });
    }

    ngOnInit() {
        this.queryContainer = this.getQueryContainer();
        this.subscribeEventHandlers();
        this.getData();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
